import React from 'react'
import styled from 'styled-components'
import {SingleChoice} from '../../../sharedComponents/components'

import PerformTaskForm from './PerformTaskForm'
import PerformTaskTitle from './PerformTaskTitle'
import {EventStatusCode, PerformableTask} from '../../../state/performTask/state'
import {FormContainer} from './PerformCoolerCoolingTask'
import {useTranslation} from 'react-i18next'

interface ChoicesWidgetProps {
  tasks?: string[]
  onSelect: (key: 'choice', value: string) => void
  selectedChoice: string
}
const ChoicesWidget = ({tasks, onSelect, selectedChoice}: ChoicesWidgetProps) => {
  return tasks && tasks.length > 0 ? (
    <ChoicesWidgetContainer>
      {tasks.map((task, index) => (
        <SingleChoice
          type="radio"
          label={task}
          name="singleChoices"
          value={task}
          id={`${task}_${index}`}
          key={`${task}_${index}`}
          checked={task === selectedChoice}
          onClick={() => onSelect('choice', task)}
          readOnly
        />
      ))}
    </ChoicesWidgetContainer>
  ) : null
}

const ChoicesWidgetContainer = styled.div`
  padding: 2rem 0;
  display: grid;
  grid-auto-flow: row;
  gap: 1rem;
`

interface PerformSingleChoiceTaskProps {
  task: PerformableTask
  setValue: any
  onAssetSaved: () => void
  onAssetRemoved: (assetId: string) => void
  payload: any
  handleRemove: () => void
  hasCurrentEvent?: boolean
  currentEventId?: string
}

const PerformSingleChoiceTask = ({
  task,
  setValue,
  onAssetSaved,
  onAssetRemoved,
  payload,
  handleRemove,
  hasCurrentEvent,
  currentEventId
}: PerformSingleChoiceTaskProps) => {
  const {t} = useTranslation('tasks')
  return (
    <FormContainer>
      <PerformTaskTitle task={task} />
      <ChoicesWidget tasks={task.choices} onSelect={setValue} selectedChoice={payload.choice} />
      <PerformTaskForm
        onInputChange={setValue}
        payload={payload}
        onAssetSaved={onAssetSaved}
        onAssetRemoved={onAssetRemoved}
        handleRemove={!!task.scheduleInstance || task.status === EventStatusCode.IN_PROGRESS ? handleRemove : undefined}
        setValue={setValue}
        confirm={
          task.scheduleInstance || task.status === EventStatusCode.IN_PROGRESS
            ? t(
                'tasks:labels.confirmRemoveTask',
                'Are you sure you want to delete this task? This will also remove any associated resolved alarms.'
              )
            : undefined
        }
        hasCurrentEvent={!!hasCurrentEvent}
        currentEventId={currentEventId}
      />
    </FormContainer>
  )
}

export default PerformSingleChoiceTask
